export default Object.freeze({
    AUTH: 'auth',
    GLOBAL: 'global',
});
